/* eslint-disable prefer-template */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  addUser,
  updateUser,
  deleteUser,
  businessDatadb,
} from './fake-data'
import { getIssuerInfo } from './thunks'
import { users } from '../invoice-issuance/db/users'
import { getTemporalToken } from '../../../billing-api'
import { getAPIEndpointURL as getAPIEndpointURL2 } from '../../../utility/utils'

const BASE_URL = getAPIEndpointURL2()+'/api'

const userName = JSON.parse(localStorage.getItem('userBilligData'))
const userLogin = { companyId: userName?.username }
const user = users.find((user) => user.companyId === userLogin.companyId)

export const request = async (url, method, headers, data) => {
  const response = await fetch(url, {
    method,
    headers,
    body: JSON.stringify(data),
  })
  return response.json()
}

export const editIssuerConfig = async (token, userId, data) => {
  return await request(
    `${BASE_URL}/users/${userId}/config`,
    'PUT',
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data
  )
}

export const authorizeAccess = async (provider) => {
  const token = await getTemporalToken(user)

  return await request(
    `${BASE_URL}/users/${user.userId}/email-monitoring/auth/${provider}`,
    'POST',
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    }
  )
}

export const revokeAccess = async () => {
  const token = await getTemporalToken(user)

  return await request(
    `${BASE_URL}/users/${user.userId}/email-monitoring/auth`,
    'DELETE',
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    }
  )
}

export const getData = createAsyncThunk(
  'businessManager/getData',
  async (filters) => {
    return businessDatadb
  }
)

export const addUserAction = createAsyncThunk(
  'businessManager/addUser',
  async (user) => {
    const newUser = addUser(user)
    return newUser
  }
)

export const editAction = createAsyncThunk(
  'businessManager/editBusiness',
  async (data, includeEmailConfig = false) => {
    const token = await getTemporalToken(user)
    const payload = {
      id: user.userId,
      clientName: data?.clientName ?? '',
      email: data?.email ?? '',
      incomingEmail: data?.incomingEmail ?? '',
      phoneNumber: data?.phoneNumber ?? '',
      address: data?.address ?? '',
      company: data?.company ?? '',
      municipality: data?.municipality ?? '',
      department: data?.department ?? '',
      district: data?.district ?? '',
      nit: data?.nit ?? '',
      nrc: data?.nrc ?? '',
      largeConsumer: data?.largeConsumer ?? '',
      economicActivity: data?.economicActivity ?? '',
      typeOffer: data?.typeOffer ?? '',
      typeEstablishment: data?.typeEstablishment ?? '',
      emailProvider: includeEmailConfig ? data.emailProvider : null, // o MICROSOFT
      accountType: includeEmailConfig ? data.accountType : null, // o CORPORATE
      // webhookEnabled: false, // inicialmente false
    }

    try {
      const response = await editIssuerConfig(token, user.userId, payload)

      console.log('response:', response)
    } catch (error) {
      console.error('ERROR::EDIT:', error)
    }

    const updatedUser = updateUser(data)

    return updatedUser
  }
)

export const deleteUserAction = createAsyncThunk(
  'businessManager/deleteUser',
  async (id) => {
    const updatedData = deleteUser(id)
    return id
  }
)

export const checkIfUserExists = (productCode) => {
  return businessDatadb.some(
    (item) => item.productCode !== '' && item.productCode === productCode
  )
}

const initialState = {
  data: null,
  isPending: false,
  modal: { logo: { open: false } },
}

export const businessManagerSlice = createSlice({
  initialState,
  name: 'businessManager',
  reducers: {
    setInitialData: (state) => {
      state.data = {}
    },
    setOpenModal: (state, action) => {
      const { open } = action.payload
      state.modal.logo.open = open
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload
        state.isPending = false
      })
      .addCase(getData.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(getData.rejected, (state, action) => {
        state.isPending = false
      })
      .addCase(addUserAction.fulfilled, (state, action) => {
        state.data.push(action.payload)
      })
      .addCase(editAction.fulfilled, (state, action) => {
        const updatedUser = action.payload
        // console.log('updatedUser: STORE ', updatedUser)
        state.data = updatedUser
      })
      .addCase(deleteUserAction.fulfilled, (state, action) => {
        const id = action.payload
        state.data = state.data.filter((user) => user.id !== id)
      })
      .addCase(getIssuerInfo.fulfilled, (state, action) => {
        state.data = action.payload
      }),
})

export const { setInitialData, setOpenModal } =
  businessManagerSlice.actions

export default businessManagerSlice.reducer
